export default "__VITE_ASSET__BNx2lvCo__"